






import { Component, Vue } from "vue-property-decorator";

/**
 * The grid of a Mira screen's KPI tiles (Hans, #2610102): square tiles of at least 220px, as many per
 * row as fit, so a wide screen shows more of them than the three columns before. The tiles are the
 * slot's children (`MiraKpiTile`, square from 600px); on a phone they stay one per row at their
 * natural height, where a full-width square would be mostly empty.
 *
 * Every tile is as tall as the tallest one on the screen (Taimoor, 2026-10-30): a tile whose texts
 * outgrow the square no longer stands taller than the squares beside it.
 */
@Component({ name: "MiraKpiTileGrid" })
export default class MiraKpiTileGridComponent extends Vue {}
